import "vite-dep-pre-bundle-external:/analytics/node_modules/codemirror/theme/material.css";